export const REFER_PATIENT = 'REFER_PATIENT';
export const REFER_PATIENT_SUCCESS = 'REFER_PATIENT_SUCCESS';
export const REFER_PATIENT_FAILURE = 'REFER_PATIENT_FAILURE';
